var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70011 10.1117L7.41062 14.1834C7.8248 14.1834 8.00418 14.0055 8.21929 13.7919L10.1611 11.9361L14.1847 14.8827C14.9227 15.294 15.4426 15.0774 15.6417 14.2039L18.2828 1.82814L18.2835 1.82741C18.5176 0.736551 17.889 0.309979 17.17 0.577589L1.64569 6.52117C0.586188 6.93243 0.60223 7.52307 1.46558 7.79068L5.43453 9.02519L14.6536 3.25661C15.0875 2.96931 15.482 3.12828 15.1575 3.41557L7.70011 10.1117Z",
    fill: "#A2ADB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.17b3df3f520ff32b8a0aff8b88d6622d.svg";
export { ForwardRef as ReactComponent };